import { ReactEasyForm } from "@aeco-cloud/react-easy-form";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,

  Typography,
  useTheme
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Image from "next/image";
import Link from "next/link";
import React, { useContext } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { TextContext } from "../../../pages/bepaal-statuut";
// import undraw_success from "./../../images/undraw_success.svg";
import { NavigationBackOnly, Section } from "../../form-layout";
import StepBody from "../../form-layout/StepBody";
import Markdown from "../../Markdown";
import { SendContext, StateContext } from "../BepaalStatuut";
import { SituationData } from "./Situation";

const Result = (props: {
  result: "secondaryTrue" | "secondaryFalse" | "secondaryUndecided" | "secondaryUndecidedStudent";
}) => {
  const send = useContext(SendContext);
  const state = useContext(StateContext);
  const form = useForm();
  const theme = useTheme();
  const text = useContext(TextContext);

  const onSubmit: SubmitHandler<any> = (data) => {
    send({ type: "NEXT" });
  };

  const onBack = () => {
    send({ type: "BACK" });
  };

  const situation: SituationData | undefined = state?.context?.memory.situation;
  const year = state?.context?.memory.quarter?.quarterYear;
  const quarter = state?.context?.memory.quarter?.quarterNumber;
  // const performedHours = state?.context?.memory.performedHours;

  const content = {
    secondaryTrue: {
      image: "/images/undraw_success.svg",
      titleText: text.result_true_title,
      accordion1: {
        title: text.result_true_accordion1_title,
        text: text.result_true_accordion1_text,
        button: (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "20px" }}>
            <Link href={text.result_startYourOwnBusinessButtonUrl} passHref>
              <a target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                <Button variant="contained" color="secondary" fullWidth={true}>
                  {text.result_true_accordion1_button1}
                </Button>
              </a>
            </Link>

            <Link href={text.result_adjustStatusButtonUrl} passHref>
              <a target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                <Button variant="contained" color="secondary" fullWidth={true}>
                  {text.result_true_accordion1_button2}
                </Button>
              </a>
            </Link>
          </div>
        ),
      },
      accordion2: {
        title: text.result_true_accordion2_title,
        text: text.result_true_accordion2_text,
        button: (
          <div style={{ textAlign: "center" }}>
            <Link href="/bereken-bijdrage" passHref>
              <Button
                variant="contained"
                color="secondary"
                style={{ maxWidth: "300px" }}
                fullWidth={true}
              >
                {text.result_true_accordion2_button1}
              </Button>
            </Link>
          </div>
        ),
      },
    },
    secondaryFalse: {
      image: "/images/undraw_false.svg",
      titleText: text.result_false_title,
      accordion1: {
        title: text.result_false_accordion1_title,
        text: text.result_false_accordion1_text,
        button: (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "20px" }}>
            <Link href={text.result_startYourOwnBusinessButtonUrl} passHref>
              <a target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                <Button variant="contained" color="secondary" fullWidth={true}>
                  {text.result_false_accordion1_button1}
                </Button>
              </a>
            </Link>

            <Link href={text.result_adjustStatusButtonUrl} passHref>
              <a target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                <Button variant="contained" color="secondary" fullWidth={true}>
                  {text.result_false_accordion1_button2}
                </Button>
              </a>
            </Link>
          </div>
        ),
      },
      accordion2: {
        title: text.result_false_accordion2_title,
        text: text.result_false_accordion2_text,
        button: (
          <div style={{ textAlign: "center" }}>
            <Link href={text.result_toFaqButtonUrl} passHref>
              <a target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth={true}
                  style={{ maxWidth: "300px" }}
                >
                  {text.result_false_accordion2_button1}
                </Button>
              </a>
            </Link>
          </div>
        ),
      },
    },
    secondaryUndecided: {
      image: "/images/undraw_undecided.svg",
      titleText: text.result_undecided_title,
      accordion1: {
        title: text.result_undecided_accordion1_title,
        text: text.result_undecided_accordion1_text,
        button: (
          <div style={{ textAlign: "center" }}>
            <Link href={text.result_contactAcertaButtonUrl} passHref>
              <a target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth={true}
                  style={{ maxWidth: "300px" }}
                >
                  {text.result_undecided_accordion1_button1}
                </Button>
              </a>
            </Link>
          </div>
        ),
      },
      accordion2: {
        title: text.result_undecided_accordion2_title,
        text: text.result_undecided_accordion2_text,
        button: (
          <div style={{ textAlign: "center" }}>
            <Link href="/bereken-bijdrage" passHref>
              <Button
                variant="contained"
                color="secondary"
                style={{ maxWidth: "300px" }}
                fullWidth={true}
              >
                {text.result_undecided_accordion2_button1}
              </Button>
            </Link>
          </div>
        ),
      },
    },
  };

  return (
    <ReactEasyForm form={form}>
      {/* <div style={{display: performedHours ? "block" : "none"}}>
        <p>
          <strong>Dit wordt enkel getoont in de testfase:</strong> <br></br>
          {"Gemiddelde tewerkstelling om mee te vergelijken: " +
            performedHours?.condition?.employmentRate}{" "}
          <br></br>
          {"Gemiddelde tewerkstelling: " + performedHours?.contractResults?.employmentRate}
          <br></br>
          {"Gepresteerde uren om mee te vergelijken: " +
            performedHours?.condition?.performedHours}{" "}
          <br></br>
          {"Gepresteerde uren: " + performedHours?.contractResults?.performedHours}
        </p>
      </div> */}

      <StepBody>
        <Section>
          <div
            style={{
              textAlign: "center",
              paddingLeft: theme.spacing(1.7),
              paddingRight: theme.spacing(1.7),
            }}
          >
            <Typography
              variant="h2"
              style={{ fontSize: "24pt", marginTop: theme.spacing(2) }}
              gutterBottom
            >
              {content[props.result].titleText}
            </Typography>
            <Typography
              style={{ color: theme.palette.primary.light, fontSize: "20pt" }}
              variant="h3"
            >
              {text.result_for_quarter} {quarter?.toString()} {year?.toString()}
            </Typography>
            <div style={{ marginTop: theme.spacing(3), display:"none" }}>
              <Image src={content[props.result].image} width="250px" height="250px" />
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Section
              elevation={0}
              elevationOnFocus={0}
              style={{ maxWidth: "750px" }}
              paddingVertical={0}
            >
              {situation?.situation === "student" && (
                <Markdown
                  style={{
                    textAlign: "center",
                    ...theme.typography.h6,
                    color: theme.palette.text.primary,
                  }}
                >
                  {text.result_undecided_student}
                </Markdown>
              )}
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  {content[props.result].accordion1.title}
                </AccordionSummary>
                <AccordionDetails style={{ display: "block" }}>
                  <Markdown style={{ marginBottom: theme.spacing(2) }}>
                    {content[props.result].accordion1.text}
                  </Markdown>
                  {content[props.result].accordion1.button}
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  {content[props.result].accordion2.title}
                </AccordionSummary>
                <AccordionDetails style={{ display: "block" }}>
                  <Markdown style={{ marginBottom: theme.spacing(2) }}>
                    {content[props.result].accordion2.text}
                  </Markdown>
                  {content[props.result].accordion2.button}
                </AccordionDetails>
              </Accordion>
              <div>
                <Markdown style={{ marginBottom: theme.spacing(2) }}>
                  {text.result_missing_information}
                </Markdown>
              </div>
            </Section>
          </div>
        </Section>
      </StepBody>
      <NavigationBackOnly onBack={onBack} onNext={form.handleSubmit(onSubmit)} />
    </ReactEasyForm>
  );
};
export default Result;
